import { h, Component } from 'preact';
import s from 'components/bolt/showtimes/screeningDetails.sss';
import { joinClasses, accessNested } from 'utils/utils';
import Store from 'store/store';

export default class ScreeningDetails extends Component {
	constructor(props) {
		super(props);
		this.fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');
	}

	render({ heroOption, category, index, getDetails, getHeroDetails }) {
		const { heroName, heroImage } = getHeroDetails(category.format, category, heroOption);
		const details = getDetails(category);
		const isNotFirstCategory = index > 0;
		return (
			<div class={joinClasses(s.container, this.fontStyles.showtimesTheaterFormats, isNotFirstCategory && s.isNotFirstCategory)}>
				{isNotFirstCategory && <div class={s.categoryDivider} />}
				{heroImage ? <img class={s.heroLogo} src={heroImage} alt={heroName} /> : <span class={s.heroName}>{heroName}</span>}
				{details.length > 0 && (
					<div class={s.label}>
						{details.map(deet => (<span key={deet}>{deet}</span>))}
					</div>
				)}
			</div>
		);
	}
}
